(function () {
  if (window.__productBoughtTogetherInlineLoaded) return;
  window.__productBoughtTogetherInlineLoaded = true;

  function clampQuantity(item, value) {
    var quantity = parseInt(value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;

    var max = parseInt(item.dataset.maxQuantity, 10);
    if (!isNaN(max) && max > 0) quantity = Math.min(quantity, max);

    return quantity;
  }

  function setQuantity(item, value) {
    var input = item.querySelector('[data-bundle-quantity-input]');
    if (!input) return 0;

    var quantity = clampQuantity(item, value);
    input.value = quantity;
    item.classList.toggle('is-selected', quantity > 0);
    return quantity;
  }

  function getSelectedItems(root) {
    var items = [];

    root.querySelectorAll('[data-bundle-item]').forEach(function (item) {
      var input = item.querySelector('[data-bundle-quantity-input]');
      var quantity = input ? clampQuantity(item, input.value) : 0;

      if (quantity > 0) {
        items.push({
          id: Number(item.dataset.variantId),
          quantity: quantity
        });
      }
    });

    return items;
  }

  function addBundleItems(button, form) {
    var root = document.querySelector('[data-product-bought-together-inline]');
    if (!root) return false;

    var selectedItems = getSelectedItems(root);
    if (!selectedItems.length) return false;

    var formData = new FormData(form);
    var mainVariantId = formData.get('id');
    var mainQuantity = parseInt(formData.get('quantity'), 10);
    if (!mainQuantity || mainQuantity < 1) mainQuantity = 1;

    var items = [{
      id: Number(mainVariantId),
      quantity: mainQuantity
    }].concat(selectedItems);

    button.classList.add('ajax_loading');
    button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: items,
        sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble,minicart',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            var message = data.description || 'Unable to add the selected products to the cart.';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function (response) {
        document.body.dispatchEvent(new CustomEvent('ajax:addToCart', {
          detail: {
            form: formData,
            response: response
          }
        }));

        root.querySelectorAll('[data-bundle-item]').forEach(function (item) {
          setQuantity(item, 0);
        });

        var drawerButton = document.querySelector('.push_side[data-id="#js_cart_popup"]');
        if (drawerButton) drawerButton.click();
      })
      .catch(function (error) {
        console.error(error);
        window.alert(error.message);
      })
      .finally(function () {
        button.classList.remove('ajax_loading');
        button.disabled = false;
      });

    return true;
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    root.querySelectorAll('[data-bundle-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('[data-bundle-item]');
        var input = item && item.querySelector('[data-bundle-quantity-input]');
        if (!item || !input) return;
        setQuantity(item, parseInt(input.value, 10) + 1);
      });
    });

    root.querySelectorAll('[data-bundle-minus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('[data-bundle-item]');
        var input = item && item.querySelector('[data-bundle-quantity-input]');
        if (!item || !input) return;
        setQuantity(item, parseInt(input.value, 10) - 1);
      });
    });

    root.querySelectorAll('[data-bundle-quantity-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        setQuantity(input.closest('[data-bundle-item]'), input.value);
      });
    });

    var formId = root.dataset.productFormId;
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    form.addEventListener('click', function (event) {
      var button = event.target.closest('[data-js-product-button-add-to-cart]');
      if (!button || button.disabled) return;
      if (!getSelectedItems(root).length) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addBundleItems(button, form);
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-product-bought-together-inline]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
